import React from 'react';
import { useSimulation } from 'providers/SimulationProvider';
import { openCreneauAppel } from 'utils/creneauAppel';
import COMMERCIAUX_DEPARTEMENTS from 'constants/departements_commerciaux_pv';

export default function Reminder() {
  const { handleCreneauBtn, answers } = useSimulation();
  const simulation = useSimulation();
  const transactionId = simulation?.result?.data?.hubspot_transactionId;
  const contact = answers?.Q29 || {};
  const codePostal = answers?.Q26?.postalcode?.substring(0, 2);

  // Récupération du slug du commercial en charge du département
  const slug = Object.entries(COMMERCIAUX_DEPARTEMENTS).find(
    ([, departements]) => departements.includes(codePostal),
  )?.[0];

  // Créneau d'appel pour le commercial en charge du département
  const creneauAppelUrl = slug && `https://meetings.hubspot.com/${slug}`;

  const openRendezVous = () => openCreneauAppel(creneauAppelUrl, contact);

  return (
    creneauAppelUrl && (
      <div className="flex items-center gap-1.5 flex-col items-stretch">
        <button
          className="border-none cursor-pointer bg-xblue rounded-full text-white px-6 py-4 text-[16px] font-medium leading-none"
          onClick={
            transactionId
              ? openRendezVous
              : () => handleCreneauBtn(creneauAppelUrl)
          }
        >
          Prendre rendez-vous
        </button>
      </div>
    )
  );
}

Reminder.propTypes = {};
